<template src="./RenunciaWizard.html"></template>

<script>
import {Breadcrumb, BreadcrumbItem, Step, Steps} from 'element-ui'
import {mapState} from 'vuex'
import {requestAfiliacionMixin} from "@/api/ciudadano/afiliacionApi";
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import {NotifyMixin} from "@/mixins/NotifyMixin";
import {RouterMixin} from "@/mixins/routerMixin";
import RenunciaInicio from "@/components/Ciudadano/Renuncia/RenunciaInicio/RenunciaInicio";
import RenunciaNoExitosa from "@/components/Ciudadano/Renuncia/RenunciaNoExitosa/RenunciaNoExitosa";
import RenunciaForm from "@/components/Ciudadano/Renuncia/RenunciaForm/RenunciaForm";
import RenunciaExitosa from "@/components/Ciudadano/Renuncia/RenunciaExitosa/RenunciaExitosa";

export default {
  name: "RenunciaWizard",
  components: {
    RenunciaInicio,
    RenunciaNoExitosa,
    RenunciaForm,
    RenunciaExitosa,
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    [Steps.name]: Steps,
    [Step.name]: Step,
  },
  mixins: [
    requestAfiliacionMixin,
    ScreenSizeMixin,
    NotifyMixin,
    RouterMixin
  ],
  data() {
    return {
      partidoAfiliacion: true,
      partido: {},
      loading: false,
      active: 0
    }
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
  },
  methods: {
    onValidation(status, partido = {}) {
      this.$log.debug(status)
      this.partidoAfiliacion = status
      this.active++
      this.partido = partido
    },
    onPantallaInicio() {
      this.active = 0
    },
    onCreated(valid, isCreated) {
      this.$log.debug(valid, isCreated)
      if (isCreated && valid) {
        this.active++
      }
    },
    onErrorRenuncia() {
      this.partidoAfiliacion = false
    }
  }
}
</script>
